import { handleResponseOld, makeGet, makePost } from './helpers';

const transformResponse = ({ error, result, success }) => {
    const confirmed = (result || []).filter((x) => x.status !== 'ReleaseConfirmed');
    return {
        error,
        payload: confirmed.length > 0 ? confirmed[0] : null,
        success,
    };
};

/**
 * @category Escrow API
 * @see completeEscrowDeposit
 */
type CompleteEscrowDepositParams = {
    authToken: string;
    deployment: string;
    depositId: any;
};
/**
 * Completes an escrow deposit for given depositId via Post request to Escrow API
 * @function completeEscrowDeposit
 * @category Escrow API
 * @param {CompleteEscrowDepositParams}
 * @see https://api.liveauctioneers.com/escrow/complete/DEPLOYMENT
 * @see https://github.com/LIVEauctioneers/escrow-service/blob/master/main.go
 */
export const completeEscrowDeposit = ({ authToken, deployment, depositId }: CompleteEscrowDepositParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'complete', authToken, deployment, path: '<ESCROW-API>' });
        request.send({ depositId });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

/**
 * @category Escrow API
 * @see fetchEscrowAccountInfo
 */
type FetchEscrowAccountInfoParams = {
    authToken: string;
    bidderId: number;
    deployment: string;
};
/**
 * Fetches Escrow account info for given bidderId via Get request to Escrow API
 * @function fetchEscrowAccountInfo
 * @category Escrow API
 * @param {FetchEscrowAccountInfoParams}
 * @see https://api.liveauctioneers.com/escrow/deposit/${bidderId}/DEPLOYMENT
 * @see https://github.com/LIVEauctioneers/escrow-service/blob/master/main.go
 */
export const fetchEscrowAccountInfo = ({ authToken, bidderId, deployment }: FetchEscrowAccountInfoParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ apiPath: `deposit/${bidderId}`, authToken, deployment, path: '<ESCROW-API>' });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform: transformResponse,
            })
        );
    });

/**
 * @category Escrow API
 * @see releaseEscrowDeposit
 */
type ReleaseEscrowDepositParams = {
    authToken: string;
    deployment: string;
    depositId: any;
};
/**
 * Releases Escrow deposit for given depositId via Post to Escrow API
 * @function releaseEscrowDeposit
 * @category Escrow API
 * @param {ReleaseEscrowDepositParams}
 * @see https://api.liveauctioneers.com/escrow/release/DEPLOYMENT
 * @see https://github.com/LIVEauctioneers/escrow-service/blob/master/main.go
 */
export const releaseEscrowDeposit = ({ authToken, deployment, depositId }: ReleaseEscrowDepositParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'release', authToken, deployment, path: '<ESCROW-API>' });
        request.send({ depositId });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform: transformResponse,
            })
        );
    });
